import { CopyTradePerformancePeriod } from '@flipster/apis/v1/copy-trade/types';
import { FormattedMessage } from '@flipster/i18n';
import { createDropdownSelect } from '@flipster/react/design-system/dropdown/dropdown-select';

const Dropdown = createDropdownSelect<CopyTradePerformancePeriod>();

const periods = [
  { value: '7d', days: 7 },
  { value: '30d', days: 30 },
  { value: '90d', days: 90 },
] as const satisfies { value: CopyTradePerformancePeriod; days: number }[];

interface PeriodDropdownProps {
  period: CopyTradePerformancePeriod;
  onChange: (period: CopyTradePerformancePeriod) => void;
}

export const PeriodDropdown = ({ period, onChange }: PeriodDropdownProps) => {
  return (
    <Dropdown.Root selected={period} onChange={onChange} placement='bottom-start'>
      <Dropdown.TriggerChip />
      <Dropdown.Select portal>
        {periods.map(({ value, days }) => (
          <Dropdown.Item
            key={value}
            value={value}
            label={<FormattedMessage id='Common.r251107.days_days' values={{ days }} />}
          />
        ))}
      </Dropdown.Select>
    </Dropdown.Root>
  );
};
